import React from 'react';
import './Buttons.scss';

export type ButtonSize = 'md' | 'sm';

export type ButtonIconProps = {
    icon?: React.ReactNode;
    iconPosition?: 'start' | 'end';
    iconOnly?: boolean;
    size?: ButtonSize;
};

type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & { as: 'a' } & ButtonIconProps;
type NativeButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & { as?: 'button' } & ButtonIconProps;
type ButtonProps = AnchorProps | NativeButtonProps;

const Base: React.FC<ButtonProps> = ({
    className,
    children,
    as = 'button',
    icon,
    iconPosition = 'start',
    iconOnly = false,
    size = 'md',
    ...rest
}) => {
    const classes = [
        'btn',
        size !== 'md' ? `btn--${size}` : '',
        iconOnly ? 'btn--icon-only' : '',
        className,
    ].filter(Boolean).join(' ');

    const content = (
        <>
            {icon && iconPosition === 'start' && (
                <span className="btn__icon" aria-hidden="true">{icon}</span>
            )}
            {children != null && children !== false && (
                <span className="btn__label">{children}</span>
            )}
            {icon && iconPosition === 'end' && (
                <span className="btn__icon" aria-hidden="true">{icon}</span>
            )}
        </>
    );

    if (as === 'a') {
        const anchorProps = rest as AnchorProps;
        return <a className={classes} {...anchorProps}>{content}</a>;
    }

    return (
        <button className={classes} {...(rest as NativeButtonProps)}>{content}</button>
    );
};

export default Base;
